import { motion } from 'framer-motion';
import { Shield, Scale, TrendingUp, CheckCircle2 } from 'lucide-react';
import { AnimatedSection, AnimatedItem, AnimatedCard, staggerContainer } from '@/components/animations';

const solutions = [
  {
    icon: Scale,
    title: 'Reduza riscos',
    desc: 'Decisões com base técnica, não comercial.',
  },
  {
    icon: TrendingUp,
    title: 'Evite custos desnecessários',
    desc: 'Saiba o que é obrigatório.',
  },
  {
    icon: Shield,
    title: 'Proteja-se juridicamente',
    desc: 'Parecer documentado e rastreável.',
  },
];

const transparency = [
  'Não executamos trabalhos.',
  'Não vendemos equipamentos.',
  'Não representamos operadores.',
];

export function SolutionSection() {
  return (
    <section className="py-20 md:py-28 border-t border-border bg-muted/30">
      <div className="container">
        <AnimatedSection className="max-w-4xl mx-auto" stagger>
          <AnimatedItem className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-6">
              <Shield className="w-4 h-4" />
              A Solução
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Governança técnica independente
            </h2>
          </AnimatedItem>

          <AnimatedItem>
            <p className="text-lg text-muted-foreground text-center mb-10">
              O ElevAdvisor atua como terceira parte técnica, criando uma camada
              clara entre quem propõe e quem decide.
            </p>
          </AnimatedItem>

          <motion.div
            className="grid md:grid-cols-3 gap-6 mb-10"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-50px' }}
          >
            {solutions.map((item, idx) => (
              <AnimatedCard
                key={idx}
                className="p-6 rounded-xl bg-card border border-border"
              >
                <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4">
                  <item.icon className="w-6 h-6 text-primary" />
                </div>
                <h3 className="font-semibold text-foreground mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-muted-foreground">{item.desc}</p>
              </AnimatedCard>
            ))}
          </motion.div>

          <motion.div
            className="grid md:grid-cols-3 gap-4"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {transparency.map((item, idx) => (
              <AnimatedCard
                key={idx}
                className="flex items-center gap-2 p-3 rounded-lg bg-primary/5 border border-primary/20"
              >
                <CheckCircle2 className="w-5 h-5 text-primary shrink-0" />
                <span className="text-sm text-foreground font-medium">
                  {item}
                </span>
              </AnimatedCard>
            ))}
          </motion.div>
        </AnimatedSection>
      </div>
    </section>
  );
}
